import type { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { CmtsHostRuntime } from "./appRuntime.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30000, retry: 1 },
    mutations: { retry: 0 },
  },
});

export function CmtsAppProviders(props: { runtime: CmtsHostRuntime; children: ReactNode }) {
  void props.runtime;
  return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
}

export function getCmtsQueryClient() {
  return queryClient;
}
